export const AppName = 'Toolbox'
export const FeatureFlags = []